<script setup lang="ts">
import { usePersonnelStore } from '@/stores/personnel'

const personnelStore = usePersonnelStore()
</script>

<template>
  <div class="flex gap-6 bg-surface border border-border rounded-lg px-4 py-3">
    <div class="flex flex-col">
      <span class="font-mono text-2xl text-on-surface">{{ personnelStore.onSceneCount }}</span>
      <span class="font-mono text-[0.65rem] uppercase tracking-widest text-outline mt-0.5">In Assignment</span>
    </div>
    <div class="w-px bg-border" />
    <div class="flex flex-col">
      <span class="font-mono text-2xl text-on-surface">{{ personnelStore.checkedOutCount }}</span>
      <span class="font-mono text-[0.65rem] uppercase tracking-widest text-outline mt-0.5">Checked Out</span>
    </div>
  </div>
</template>
